import React, { useState } from "react";

import Presentation from "./presentation";

const component = props => {
	const {
		emotesList,
		comment,
		isStreamer,
		isOwnProfile,
		handleDropDownPopup,
		profileHref,
		isPopUpOpen,
		selectedComment,
		isModerator,
		userPopover,
		hideMenuOptionBtn,
		showThanksBtn
	} = props;

	const [ showOptionsButton, setShowOptionsButton ] = useState ( false );

	const showButton = e => {
		e.preventDefault ();
		setShowOptionsButton ( true );
	};

	const hideButton = e => {
		e.preventDefault ();
		setShowOptionsButton ( false );
	};

	return (
		<Presentation
			comment           = { comment }
			emotesList        = { emotesList }
			hideButton        = { hideButton }
			hideMenuOptionBtn = { hideMenuOptionBtn }
			isModerator       = { isModerator }
			isOwnProfile      = { isOwnProfile }
			isPopUpOpen       = { isPopUpOpen }
			isStreamer        = { isStreamer }
			onClickOptions    = { handleDropDownPopup }
			profileHref       = { profileHref }
			selectedComment   = { selectedComment }
			showButton        = { showButton }
			showOptionsButton = { showOptionsButton }
			showThanksBtn     = { showThanksBtn }
			userPopover       = { userPopover }
		/>
	);
};

const areEqual = ( prevProps, nextProps ) => {
	if ( ( prevProps.comment == nextProps.comment )
    && ( prevProps.isPopUpOpen == nextProps.isPopUpOpen )
    && ( prevProps.isModerator === nextProps.isModerator ) )
		return true;
};

export default React.memo ( component, areEqual );
